import React, { useState } from "react";
import {Link, useHistory} from "react-router-dom";
import { connect } from "react-redux";
import { Spin, Input, Button, notification } from "antd";
import SearchIcon from "@material-ui/icons/Search";
import ModalCapcha from "../../components/ModalCapcha";

import {
  searchBang,
  saveSearchValue,
  resetSearchValue,
} from "../../redux/actions/search";
import {
  setValueVisibleFilter,
  searchBangAdv,
  setValueFilter,
} from "../../redux/actions/searchFilter";
import { GetCapCha } from "../../services/search";
import logo from "../../assets/logo.png";
// import logo from "../../assets/EITSC.png";

import Cookies from "js-cookie";
import FilterSpace from "../FilterSpace";

import "./styles.scss";
import ModalReCapcha from "../../components/ModelReCapcha";

const mapStateToProps = (state) => {
  return {
    searchFilter: state.searchFilterReducer,
  };
};

function Search({
  searchFilter,
  searchBang,
  saveSearchValue,
  setValueVisibleFilter,
  resetSearchValue,
  setValueFilter,
  searchBangAdv,
}) {
  const history = useHistory();

  const [loading, setLoading] = useState(false);

  // const [image, setImage] = useState(null);
  const [isModalVisible, setIsModalVisible] = useState(false);

  const onChange = (e) => {
    const { value } = e.target;
    setValueFilter({
      keyword: value,
    });
  };

  const onSearch = async () => {
    if (searchFilter?.keyword) {
      try {
        if (!Cookies.get("code")) {
          // const resData = await GetCapCha({
          //   width: 200,
          //   height: 80,
          // });
          // if (resData) {
          //   setImage(
          //     `data:image/jpeg;base64,${Buffer.from(
          //       resData.data,
          //       "binary"
          //     ).toString("base64")}`
          //   );
          //   setIsModalVisible(true);
          // }
          setIsModalVisible(true);
        } else {
          searchData(Cookies.get("code"));
        }
      } catch (error) {
        setLoading(false);
      }
    } else {
      notification.warning({
        description: "Nhập từ khoá tìm kiếm !",
      });
      return;
    }
  };

  const searchData = async (captcha) => {
    try {
      setLoading(true);
      if (searchFilter.visible) {
        const res = searchBangAdv({
          params: {
            keyword: searchFilter?.keyword,
            pageNum: 1,
            pageSize: 5,
            // captcha,
            hvt: searchFilter?.name,
            nam: searchFilter?.year,
            idtruong: searchFilter?.donViId,
          },
          callback: () => {
            onSearch();
          },
        });
        setLoading(false);
        if (res) {
          // Cookies.set("code", captcha);
          saveSearchValue({
            pageNum: 1,
            pageSize: 5,
            keyword: searchFilter?.keyword,
          });

          let objectData = {
            pageNum: 1,
            pageSize: 5,
            keyword: searchFilter?.keyword,
          };
          if (searchFilter?.name) {
            objectData = { ...objectData, hvt: searchFilter?.name };
          }
          if (searchFilter?.year) {
            objectData = { ...objectData, nam: searchFilter?.year };
          }
          if (searchFilter?.donViId) {
            objectData = { ...objectData, donViId: searchFilter?.donViId };
          }
          const search = new URLSearchParams(objectData).toString();

          setIsModalVisible(false);
          history.push({
            pathname: "/main",
            search,
          });
        }
      } else {
        const res = await searchBang({
          params: {
            pageNum: 1,
            pageSize: 5,
            keyword: searchFilter?.keyword,
            // captcha,
          },
          callback: () => {
            onSearch();
          },
        });
        setLoading(false);
        if (res) {
          // Cookies.set("code", captcha);
          saveSearchValue({
            pageNum: 1,
            pageSize: 5,
            keyword: searchFilter?.keyword,
          });
          const search = new URLSearchParams({
            pageNum: 1,
            pageSize: 5,
            keyword: searchFilter?.keyword,
          }).toString();
          setIsModalVisible(false);
          history.push({
            pathname: "/main",
            search,
          });
        }
      }
    } catch (error) {
      setLoading(false);
    }
  };

  return (
    <>
      {/*<div className="mr-4">*/}
      {/*  <div className="wrap-header d-flex align-items-center justify-content-end">*/}
      {/*    <Link to={'/yeu-cau-cap-ban-sao'} className="text-header">*/}
      {/*      Yêu cầu cấp bản sao*/}
      {/*    </Link>*/}
      {/*  </div>*/}
      {/*</div>*/}
      <Spin spinning={loading}>
        <div
          className="d-flex align-items-center justify-content-center main-content"
        >
          <div
            className="d-flex flex-column justify-content-center"
            style={{ marginTop: "-10%", width: "80%" }}
          >
            <div className="row">
              <div className="col-md-3" />
              <div className="col-md-6">
                <div className="text-center" style={{ marginBottom: 40 }}>
                  <img
                    // width="350px"
                    className="main-logo"
                    src={logo}
                    alt="logo"
                    style={{ cursor: "pointer" }}
                  />
                  {/* <img
                    width="380px"
                    src={logo}
                    alt="JBTech logo"
                    style={{ cursor: "pointer" }}
                  /> */}
                </div>

                <div style={{ marginBottom: 24 }} className="text-center">
                  <Input
                    allowClear
                    value={searchFilter?.keyword}
                    onChange={onChange}
                    onPressEnter={onSearch}
                    prefix={
                      <SearchIcon
                        style={{ color: "#9aa0a6", fontSize: 20 }}
                        className="mr-2"
                      />
                    }
                    placeholder="Tìm kiếm thông tin văn bằng"
                    className="wrap-search"
                    // style={{
                    //   borderRadius: 24,
                    //   boxShadow: "rgba(0, 0, 0, 0.16) 0px 1px 6px 0px",
                    //   lineHeight: "32px",
                    // }}
                  />
                </div>
                <div
                  style={{
                    width: "100%",
                    height: searchFilter.visible ? 10 : 0,
                    transition: "height 0.6s, margin 0.5s",
                    marginBottom: searchFilter.visible ? 20 : 0,
                    overflow: "hidden",
                  }}
                  className={`${searchFilter.visible ? "height-filter" : "a"}`}
                >
                  <FilterSpace />
                </div>
                <div className="d-flex align-items-center justify-content-center">
                  <Button
                    onClick={() => {
                      onSearch();
                    }}
                    className="btn-search mr-md-2 mr-1"
                  >
                    Tìm kiếm thông tin
                  </Button>
                  <Button
                    onClick={() => {
                      setValueVisibleFilter(!searchFilter.visible);
                      resetSearchValue();
                    }}
                    className="btn-search"
                  >
                    {searchFilter.visible
                      ? `Ẩn tìm kiếm nâng cao`
                      : `Hiện tìm kiếm nâng cao`}
                  </Button>
                </div>
                <div className="text-center mt-3">
                  {/*<div className="text-header-2">*/}
                  {/*  Yêu cầu cấp bản sao văn bằng chứng chỉ?*/}
                  {/*</div>*/}
                  <div>
                    <span className="text-header-2">
                      Yêu cầu cấp bản sao văn bằng chứng chỉ?
                    </span>
                    <span className="text-header ml-1">
                      <Link to={'/yeu-cau-cap-ban-sao'}>
                        <span className="text-primary">Click vào đây</span>
                      </Link>
                    </span>
                  </div>
                </div>
              </div>
              <div className="col-md-3" />
            </div>
          </div>
        </div>
        <div
          style={{
            color: "#70757a",
            fontSize: 14,
            position: "fixed",
            left: 0,
            bottom: 0,
            lineHeight: 4,
            textAlign: "center",
            // paddingLeft: '2rem',
            width: "100%",
            backgroundColor: '#f2f2f2'
          }}
        >
          <span>
            <a
              href="https://backan.edu.vn/"
              // href="https://staging.jbcert.vn/"
              target="_blank"
              rel="noreferrer"
              style={{
                color: '#70757a',
              }}
            >
              Sở giáo dục đào tạo tỉnh Bắc Kạn
            </a>
          </span>
        </div>
      </Spin>
      {isModalVisible && (
        <ModalReCapcha
          setIsModalVisible={setIsModalVisible}
          isModalVisible={isModalVisible}
        />
      )}
      {/*{isModalVisible ? (*/}
      {/*  <ModalCapcha*/}
      {/*    image={image}*/}
      {/*    setIsModalVisible={setIsModalVisible}*/}
      {/*    isModalVisible={isModalVisible}*/}
      {/*    callback={searchData}*/}
      {/*    setImage={setImage}*/}
      {/*  />*/}
      {/*) : null}*/}
    </>
  );
}

export default connect(mapStateToProps, {
  searchBang,
  saveSearchValue,
  setValueVisibleFilter,
  resetSearchValue,
  setValueFilter,
  searchBangAdv,
})(Search);
